export const removeSpacesAndEncode = (str) => {
  return str.replace(/\s/g, '');
}